/* eslint-disable camelcase */

export interface AdAccount {
    customer_id: string;
    id: number;
    type: string;
    type_id: number;
}

export interface Account {
    ad_account: AdAccount;
    id: number;
    name: string;
    type: string;
    type_id: number;
}

export interface Client {
    accounts: [Account]
    company_name: string;
    id: number;
    logo?: string;
    name: string;
    shared: boolean;
    type_id: number;
    type: string;
}

export enum PLATFORMS {
    CLIENT = 'client',
    FACEBOOK_ADS = 'facebook_ads',
    GOOGLE_ADS = 'google_ads',
}

export type ByPlatform<T> = {
    [platform in PLATFORMS]: T
}
